import actions from "./actions";
import SitesStateRecord from "@infinode/records/reducers/SitesStateRecord";
import DataSourceValueRecord from "@infinode/records/DataSourceValueRecord";
import immutableUtils from "@iso/utils/immutableUtils";
import { Map } from "immutable";
import { createSiteRecord } from "@infinode/records/SiteRecord";
import reducerUtils from "../reducerUtils";
import { SETTINGS_DATA_SOURCE_TYPE_PROP_NAMES } from "@infinode/components/settings/constants";

export default function sitesReducer(state = SitesStateRecord(), action) {
  switch (action.type) {
    case actions.GET_SITES_REQUEST:
      return state.merge({ sites: Map(), loading: true, error: null });
    case actions.GET_SITES_SUCCESS:
      const newSitesMap = action.sites ? immutableUtils.listToMap(action.sites.map(s => createSiteRecord(s))) : Map();
      return state.merge({
        sites: newSitesMap,
        loading: false,
        selectedSiteId: newSitesMap.size > 0 ? action.sites[0].id : ""
      });
    case actions.GET_SITE_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.GET_SITE_SUCCESS:
      return state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.update("sites", sites => sites.set(action.site.id, createSiteRecord(action.site)));
      });
    case actions.DELETE_SITE_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.DELETE_SITE_SUCCESS:
      return state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.update("sites", sites => sites.delete(action.id));
      });
    case actions.UPDATE_SITE_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.UPDATE_SITE_SUCCESS:
      return state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.update("sites", sites => sites.set(action.site.id, createSiteRecord(action.site)));
      });
    case actions.CREATE_SITE_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.CREATE_SITE_SUCCESS:
      return state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.update("sites", sites => sites.set(action.site.id, createSiteRecord(action.site)));
      });
    case actions.ADD_SITE_DATA_SOURCE_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.ADD_SITE_DATA_SOURCE_SUCCESS:
      return state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.updateIn(
          ["sites", action.siteId, "dataSource", SETTINGS_DATA_SOURCE_TYPE_PROP_NAMES[action.dataSourceType]],
          values =>
            values.find(v => v.entityId === action.zoneId)
              ? values
              : values.push(DataSourceValueRecord({ entityId: action.zoneId, positive: action.positive }))
        );
      });
    case actions.REMOVE_SITE_DATA_SOURCE_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.REMOVE_SITE_DATA_SOURCE_SUCCESS:
      const result = state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.updateIn(
          ["sites", action.siteId, "dataSource", SETTINGS_DATA_SOURCE_TYPE_PROP_NAMES[action.dataSourceType]],
          values => values.filter(v => v.entityId !== action.zoneId)
        );
      });
      return result;
    case actions.UPDATE_SITE_DEMAND_CONFIG_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.UPDATE_SITE_DEMAND_CONFIG_SUCCESS:
      return state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.updateIn(["sites", action.siteId], s =>
          s.merge({ demandOn: action.demandSwitch, demandThreshold: action.demandThreshold })
        );
      });
    case actions.SITES_ERROR:
      return state.merge({ loading: false, error: action.error });
    case actions.SET_SELECTED_SITE_ID:
      return state.update("selectedSiteId", id => (state.sites.has(action.siteId) ? action.siteId : id));
    default:
      return state;
  }
}
